import React from 'react'
import ReactDOM from 'react-dom'
import { PersistGate } from 'redux-persist/integration/react'
import { ThemeProvider } from '@sainsburys-tech/theme-provider'
import './fable.css'
import './index.css'
import './index.scss'
import { Provider } from 'react-redux'
import App from './App'
import * as serviceWorker from './serviceWorker'
import * as store from './store'


ReactDOM.render(
  <Provider store={store.store}>
    <PersistGate loading={null} persistor={store.persistor}>
      <ThemeProvider brand="sainsburys">
        <App />
      </ThemeProvider>
    </PersistGate>
  </Provider>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister()
